
import React from 'react';
import { User } from 'lucide-react';
import UserAvatar from '@/components/ui/UserAvatar';

interface InviteChoicePopupProps {
  inviterName: string;
  inviterAvatar?: string;
  clickedAt?: string;
  onConnectChoice: () => void;
  onJustMeChoice: () => void;
}

export const InviteChoicePopup: React.FC<InviteChoicePopupProps> = ({
  inviterName,
  inviterAvatar,
  clickedAt,
  onConnectChoice,
  onJustMeChoice
}) => {
  const formatTimeAgo = (timestamp?: string) => {
    if (!timestamp) return '';

    const now = new Date();
    const clickTime = new Date(timestamp);
    const diffMinutes = Math.floor((now.getTime() - clickTime.getTime()) / (1000 * 60));

    if (diffMinutes < 1) return 'just now';
    if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`;
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold mb-2">
            You've been invited to BlissNet!
          </h2>
          <p className="text-gray-600">
            {inviterName} invited you to connect on BlissNet
          </p>
          {clickedAt && (
            <p className="text-gray-500 text-sm">
              Invitation clicked {formatTimeAgo(clickedAt)}
            </p>
          )}
        </div>

        <div className="flex items-center justify-center mb-6">
          {inviterAvatar ? (
            <UserAvatar user={{ photo_urls: [inviterAvatar] }} size="md" className="w-16 h-16 rounded-full" />
          ) : (
            <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
              <User size={32} className="text-blue-600" />
            </div>
          )}
        </div>

        <div className="space-y-3">
          <button
            onClick={onConnectChoice}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 transition-colors"
          >
            Connect with {inviterName}
          </button>
          
          <button
            onClick={onJustMeChoice}
            className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            Just me (skip connection)
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-4">
          You'll complete your profile setup next
        </p>
      </div>
    </div>
  );
};

